import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from '../U3204';
import { useU3204Context } from '../U3204Context';
import { u3204BuildConversationHeaderLabel } from '../utils/u3204BuildConversationHeaderLabel';

const U3204ConversationHeader: React.FC = () => {
  const { t } = useTranslation(NS);
  const { isNewChat, selectedMissionId, activeMission, activeConversationTitle } = useU3204Context();

  const label = useMemo(
    () =>
      u3204BuildConversationHeaderLabel({
        isNewChat,
        selectedMissionId,
        missionTitle: activeMission?.title ?? null,
        conversationTitle: activeConversationTitle,
        placeholderLabel: t('newConversation', { ns: NS }),
      }),
    [activeConversationTitle, activeMission?.title, isNewChat, selectedMissionId, t],
  );

  if (!label) {
    return null;
  }

  return (
    <header className="shrink-0 border-b border-border px-4 py-3">
      <h1 className="truncate text-sm font-semibold text-foreground" title={label}>
        {label}
      </h1>
    </header>
  );
};

export default U3204ConversationHeader;
